module.exports = __webpack_public_path__ + "img/te-15.baf11748.png";